import { LoadState } from "../../constants/enums";
import { IUserProfile, IUsersState } from "./userProfile.types";

export const initialUser: IUserProfile = {
  first_name: "",
  personal_email: "",
  email: "",
  user_uuid: "",
  branch_uuid: "",
  branch_name: "",
  last_name: "",
  job_title: null,
  manager_uuid: null,
  hierarchy_uuids: null,
  user_type: null,
  assigned_phone_number: null,
  shared_email: null,
  mobile: null,
  branches: [],
  home_phone: null,
  linkedin_profile: null,
  hire_date: null,
  last_day_at_work: null,
  department: null,
  fax: null,
  date_of_birth: null,
  mother_maiden_name: null,

  affilated_company_outlet_uuids: [],
  // photo: null,
  signature: null,
  street_address: null,
  unit_or_suite: null,
  city: null,
  province_or_state: null,
  postal_code: null,
  country: null,
  languages_known: null,
  documents: null,
  status: "ACTIVE",
  user_fact_id: 0,
  branch_code: null,
  created_by_name: "",
  created_by_uuid: "",
  csr: null,
  csr_code: null,
  full_name: "",
  insert_ts: "",
  marketer: null,
  marketer_code: null,
  producer_one: null,
  producer_one_code: null,
  producer_three: null,
  producer_three_code: null,
  producer_two: null,
  producer_two_code: null,
  role_uuid: "",
  role_value: "",
  role_name: "",
  user_dim_id: 0,
  user_profile_id: 0,
  enable_chat_assignment: false,
};

export const initialUserProfileState: IUsersState = {
  users: {
    data: [],
    totalRecords: 0,
    currentRecords: 0,
    meta: {
      use_count: 0,
      created_count: 0,
    },
    loading: LoadState.NotLoaded,
    user: initialUser,
    userLoading: LoadState.NotLoaded,
    error: null,
  },
};
